import { useDispatch } from "react-redux";
import { setUser } from "../../redux/slice/user";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../redux/slice/form";

const useClearLocalStorage = () => {
  const dispatch = useDispatch();

  return () => {
    let localData = [
      {
        name: "user",
        action: (e) => setUser(e),
      },
      {
        name: "formType",
        action: (e) => setFormType(e),
      },
      {
        name: "formStep",
        action: (e) => setFormStep(e),
      },
      {
        name: "formUser",
        action: (e) => setFormUser(e),
      },
      {
        name: "formDetail",
        action: (e) => setFormDetail(e),
      },
    ];
    localData.forEach((item) => dispatch(item.action(null)));
  };
};

export default useClearLocalStorage;
